import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/clay-tokens.css';

const Registratioon = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isStandalonePage = typeof isOpen !== 'boolean';
  const isVisible = isStandalonePage ? true : isOpen;

  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 768 : false
  );

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClose = () => {
    if (typeof onClose === 'function') {
      onClose();
      return;
    }

    // history.length counts the page the browser was on before this site
    // too, so it's ~always > 1 and unreliable for "is there in-app history
    // to go back to". react-router's history.state.idx only increments on
    // entries this app itself pushed, so idx > 0 is the real signal.
    const idx = window.history.state?.idx;
    if (typeof idx === 'number' && idx > 0) {
      navigate(-1);
      return;
    }

    navigate('/');
  };

  if (!isVisible) return null;

  const handlePlayerSelect = () => {
    if (typeof onClose === 'function') onClose();
    setTimeout(() => navigate('/PlayerReg'), 100);
  };

  const handleOrganizerSelect = () => {
    if (typeof onClose === 'function') onClose();
    setTimeout(() => navigate('/Reg'), 100);
  };

  return (
    <div
      className="modal-overlay"
      onClick={handleClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000,
        padding: isMobile ? '16px' : '20px',
      }}
    >
      <div
        className="modal-content"
        onClick={e => e.stopPropagation()}
        style={{
          background: 'var(--surface-white)',
          borderRadius: isMobile ? 'var(--clay-radius-sm)' : 'var(--clay-radius-md)',
          padding: isMobile ? '24px 16px 20px' : '40px',
          width: '100%',
          maxWidth: isMobile ? '340px' : '700px',
          position: 'relative',
          boxShadow: 'var(--clay-shadow-raised)',
          fontFamily: 'var(--font-body)',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: isMobile ? '8px' : '0' }}>
          <button
            onClick={handleClose}
            style={{
              background: 'var(--surface-100)',
              border: 'none',
              borderRadius: '50%',
              width: isMobile ? '28px' : '32px',
              height: isMobile ? '28px' : '32px',
              fontSize: isMobile ? '16px' : '20px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'var(--ink-600)',
              lineHeight: 1,
              flexShrink: 0,
            }}
          >×</button>
        </div>

        <h2 style={{
          fontFamily: 'var(--font-display)',
          fontSize: isMobile ? '18px' : '28px',
          marginBottom: isMobile ? '4px' : '10px',
          color: 'var(--ink-900)',
          textAlign: 'center',
        }}>{t('authPages.chooseAccountType')}</h2>

        <p style={{
          fontSize: isMobile ? '12px' : '15px',
          color: 'var(--ink-600)',
          textAlign: 'center',
          marginBottom: isMobile ? '20px' : '30px',
        }}>{t('authPages.selectHowToUse')}</p>

        <div style={{
          display: 'flex',
          flexDirection: isMobile ? 'row' : 'row',
          gap: isMobile ? '12px' : '30px',
          justifyContent: 'center',
        }}>
          {/* Player card */}
          <div
            onClick={handlePlayerSelect}
            style={{
              flex: 1,
              maxWidth: isMobile ? '140px' : '250px',
              background: 'var(--surface-50)',
              borderRadius: isMobile ? 'var(--clay-radius-sm)' : 'var(--clay-radius-md)',
              padding: isMobile ? '16px 10px' : '30px 20px',
              cursor: 'pointer',
              border: '2px solid transparent',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: isMobile ? '8px' : '12px',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--amber-600)'; e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = 'var(--clay-shadow-raised-sm)'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = 'transparent'; e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
          >
            <img
              src="/nkarner/plyr.png"
              alt={t('authPages.player')}
              style={{
                width: isMobile ? '70px' : '140px',
                height: isMobile ? '70px' : '140px',
                objectFit: 'cover',
                borderRadius: '8px',
              }}
            />
            <h3 style={{ fontFamily: 'var(--font-display)', fontSize: isMobile ? '14px' : '22px', margin: 0, color: 'var(--ink-900)' }}>{t('authPages.player')}</h3>
            {!isMobile && <p style={{ fontSize: '14px', color: 'var(--ink-600)', textAlign: 'center', margin: 0, lineHeight: 1.5 }}>{t('authPages.playerDescLong')}</p>}
            {isMobile && <p style={{ fontSize: '10px', color: 'var(--ink-400)', textAlign: 'center', margin: 0, lineHeight: 1.4 }}>{t('authPages.playerDescShort')}</p>}
          </div>

          {/* Organizer card */}
          <div
            onClick={handleOrganizerSelect}
            style={{
              flex: 1,
              maxWidth: isMobile ? '140px' : '250px',
              background: 'var(--surface-50)',
              borderRadius: isMobile ? 'var(--clay-radius-sm)' : 'var(--clay-radius-md)',
              padding: isMobile ? '16px 10px' : '30px 20px',
              cursor: 'pointer',
              border: '2px solid transparent',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: isMobile ? '8px' : '12px',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--amber-600)'; e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.boxShadow = 'var(--clay-shadow-raised-sm)'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = 'transparent'; e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
          >
            <img
              src="/nkarner/kostyum.png"
              alt={t('authPages.organizer')}
              style={{
                width: isMobile ? '70px' : '140px',
                height: isMobile ? '70px' : '140px',
                objectFit: 'cover',
                borderRadius: '8px',
              }}
            />
            <h3 style={{ fontFamily: 'var(--font-display)', fontSize: isMobile ? '14px' : '22px', margin: 0, color: 'var(--ink-900)' }}>{t('authPages.organizer')}</h3>
            {!isMobile && <p style={{ fontSize: '14px', color: 'var(--ink-600)', textAlign: 'center', margin: 0, lineHeight: 1.5 }}>{t('authPages.organizerDescLong')}</p>}
            {isMobile && <p style={{ fontSize: '10px', color: 'var(--ink-400)', textAlign: 'center', margin: 0, lineHeight: 1.4 }}>{t('authPages.organizerDescShort')}</p>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Registratioon;
